import React, { useEffect, useContext } from "react";
import { useSignIn, useSignOut } from "react-auth-kit";
import { useNavigate } from "react-router-dom";
import { getLogo } from "../../services/Base/base-service";

import UserContext from "../../store/user-context";

import classes from "../../assets/PaInfo.module.css";

const PaInfo = () => {
  const userContext = useContext(UserContext);

  const signIn = useSignIn();
  const signOut = useSignOut();
  const navigate = useNavigate();

  useEffect(() => {
    if (
      userContext.selectedClientName !== null &&
      userContext.selectedClientFiscalCode !== null
    ) {
      setTimeout(() => {
        getLogo(
          { fiscalCode: userContext.selectedClientFiscalCode },
          signIn,
          signOut,
          navigate,
          userContext
        ).then((response) => {
          if (response.error === undefined) {
            response.blob().then((blob) => {
              let url = window.URL.createObjectURL(blob);
              let a = document.getElementById("logo");
              a.src = url;
            });
          } else {
            // setError(response.error);
          }
        });
      }, 100);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userContext.selectedClientName, userContext.selectedClientFiscalCode]);

  return (
    <div className={classes.wrapper}>
      <span className={classes["pa-logo"]}>
        <img alt="pa-logo" id="logo" />
      </span>
      <div className="text-nowrap">
        <p className="m-0">Comune di</p>
        {userContext.selectedClientName !== null && (
          <p className="m-0">{userContext.selectedClientName}</p>
        )}
      </div>
    </div>
  );
};

export default PaInfo;
